import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Button,
  Typography,
  TextField
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const DynamicFileUpload = (props) => {
  const onDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination) return; // If dropped outside, no action
    if (destination.index === source.index) return; // No change if dropped in the same position

    // Reorder rows (swap entire row object, including file)
    const reorderedRows = Array.from(props.rows);
    const [movedRow] = reorderedRows.splice(source.index, 1); // Remove the moved row
    reorderedRows.splice(destination.index, 0, movedRow); // Insert at the new position

    props.setRows(reorderedRows); // Update rows in parent state
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Property Documents</h4>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable-rows">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className="row-list"
            >
              {props.rows.map((row, index) => (
                <Draggable
                  key={row.orderId}
                  draggableId={`row-${row.orderId}`}
                  index={index}
                >
                  {(provided) => (
                    <Grid
                      container
                      alignItems="center"
                      spacing={3}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                    <Grid item md={3}>
  <FormControl
    fullWidth
    sx={{ marginTop: 2 }}
    error={!!row.errors?.DocumentType}
  >
    <InputLabel>Document Type</InputLabel>
    <Select
      value={row.DocumentType || ""}
      label="Document Type"
      onChange={(e) =>
        props.handleDocumentTypeChange(index, e.target.value)
      }
    >
      <MenuItem value="Ec">EC</MenuItem>
      <MenuItem value="Patta">Patta</MenuItem>
      <MenuItem value="Other">Other</MenuItem>
    </Select>
    {row.errors?.DocumentType && (
      <Typography color="error" variant="caption">
        {row.errors.DocumentType}
      </Typography>
    )}
  </FormControl>
</Grid>

<Grid item md={3}>
  <TextField
    fullWidth
    label="Document Name"
    value={row.DocumentName || ""}
    onChange={(e) => props.handleTextChange(index, e.target.value)}
    error={!!row.errors?.DocumentName}
    helperText={row.errors?.DocumentName}
  />
</Grid>

<Grid item md={4}>
  <input
    type="file"
    onChange={(e) =>
      props.handleFileChange(index, e.target.files[0])
    }
    className="form-control"
  />
  {row.errors?.file && (
    <Typography color="error" variant="caption">
      {row.errors.file}
    </Typography>
  )}
</Grid>


                      <Grid item md={2}>
                        {index > 0 && (
                          <Button
                            variant="contained"
                            color="error"
                            fullWidth
                            onClick={() => props.removeRow(index)}
                          >
                            ✕
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <Button
        variant="contained"
        color="success"
        onClick={props.addRow}
        sx={{ marginTop: "10px" }}
      >
        + Add More
      </Button>
    </div>
  );
};

export default DynamicFileUpload;
